/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_accionProyecto as accionProyecto,
  rec_Bo as Bo,
  rec_BuscadorPersona as BuscadorPersona,
  rec_EstadoError as EstadoError,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Ki as Ki,
  rec_React as React,
  rec_Rx as Rx,
  rec_SelectorMultiple as SelectorMultiple,
  rec_Yx as Yx,
  rec_api as api,
  rec_obtenerUsuario as obtenerUsuario,
  rec_tO as tO,
} from "../../runtime/index.jsx";
export function EquipoProyecto({ proyecto: e, onCambio: t }) {
  let n = Go(),
    [r, i] = (0, React.useState)(``),
    a = accionProyecto(e, `planner.proyectos.miembros`),
    o = e.miembros ?? [];
  async function s(n) {
    try {
      (await api(`/proyectos/${e.id}/miembros`, {
        method: `POST`,
        body: JSON.stringify({
          usuarioId: n.id,
          usuarioNombre: n.nombre,
          usuarioCorreo: n.correo,
          rolProyecto: `COLABORADOR`,
          actorNombre: obtenerUsuario()?.nombre,
        }),
      }),
        t());
    } catch (e) {
      i(e.message);
    }
  }
  async function c(n, r) {
    try {
      (await api(`/proyectos/${e.id}/miembros/${n.id}`, {
        method: `PUT`,
        body: JSON.stringify({
          rolProyecto: r,
        }),
      }),
        t());
    } catch (e) {
      i(e.message);
    }
  }
  async function l(r) {
    try {
      (await api(`/proyectos/${e.id}/miembros/${r.id}`, {
        method: `DELETE`,
      }),
        t(),
        n.conDeshacer(`${tO(r)} ya no está en el proyecto`, async () => {
          try {
            (await api(`/proyectos/${e.id}/miembros`, {
              method: `POST`,
              body: JSON.stringify({
                usuarioId: r.usuarioId,
                usuarioNombre: r.usuarioNombre,
                usuarioCorreo: r.usuarioCorreo,
                rolProyecto: r.rolProyecto,
                actorNombre: obtenerUsuario()?.nombre,
              }),
            }),
              t(),
              n.ok(`${tO(r)} vuelve al proyecto`));
          } catch (e) {
            n.error(e.message);
          }
        }));
    } catch (e) {
      i(e.message);
    }
  }
  return (
    <div
      className={`flex flex-col gap-4`}
      children={[
        <EstadoError mensaje={r} onReintentar={() => i(``)} />,
        a && (
          <div
            className={`rounded-2xl border border-(--border) bg-(--bg) p-4`}
            children={[
              <p
                className={`mb-2 text-sm font-medium text-(--text-h)`}
                children={`Agregar miembro`}
              />,
              <BuscadorPersona
                placeholder={`Buscar persona en el padron…`}
                excluirIds={o.map((e) => e.usuarioId)}
                onSelect={s}
              />,
            ]}
          />
        ),
        <ul
          className={`flex flex-col gap-2`}
          children={o.map((t) => (
            <li
              key={t.id}
              className={`${Bo} flex flex-wrap items-center gap-3`}
              children={[
                <div
                  className={`min-w-0 flex-1`}
                  children={[
                    <p
                      className={`truncate text-sm font-medium text-(--text-h)`}
                      children={t.usuarioNombre || `Usuario ${t.usuarioId}`}
                    />,
                    <p
                      className={`truncate text-xs text-(--text)`}
                      children={t.usuarioCorreo}
                    />,
                  ]}
                />,
                a && t.usuarioId !== e.propietarioUsuarioId ? (
                  <div
                    className={`w-44`}
                    children={
                      <SelectorMultiple
                        value={t.rolProyecto}
                        onChange={(e) => e && c(t, e)}
                        placeholder={Yx(t.rolProyecto)}
                        opciones={Rx.map((e) => ({
                          value: e.codigo,
                          label: e.label,
                        }))}
                      />
                    }
                  />
                ) : (
                  <span
                    className={`rounded-full bg-(--accent-bg) px-2 py-0.5 text-xs text-(--text-h)`}
                    children={Yx(t.rolProyecto)}
                  />
                ),
                a && t.usuarioId !== e.propietarioUsuarioId && (
                  <button
                    type={`button`}
                    onClick={() => l(t)}
                    aria-label={`Quitar`}
                    className={`rounded-lg p-1.5 text-(--text) hover:bg-(--error-bg) hover:text-(--error)`}
                    children={<Ki className={`h-4 w-4`} />}
                  />
                ),
              ]}
            />
          ))}
        />,
      ]}
    />
  );
}
